/*@flow*/
import * as t from 'lib/t';

export default t.subtype(
  t.Object,
  v => v && Object.keys(v).length > 0,
  'NonEmptyObject'
);
